<template>
    <div class="arrow_box z-10">
        <slot></slot>
    </div>
</template>
<script>
export default {}
</script>

<style lang="scss" scoped>
$size: 12px;
$border-color: #888;

.arrow_box {
    position: absolute;
    border: 1px solid $border-color;
    @apply bg-white rounded-lg p-4 text-black;
}

.arrow_box:after, .arrow_box:before {
    bottom: 100%;
    left: 12.5%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
}

.arrow_box:after {
    border-bottom-color: white;
    border-width: $size;
    margin-left: -$size;
}

.arrow_box:before {
    border-bottom-color: $border-color;
    border-width: $size + 1;
    margin-left: -($size + 1);
}
</style>
